"use client";
import { t as useImpressionRef } from "../chunks/use-impression-ref-k081rlv0dt8gci3d.js";
import { t as cn } from "../chunks/cn-dk9nmc4mhy1765ud.js";
import { t as Container } from "../chunks/container-bmokyww153ys88nc.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/box/box.tsx
/**
* Flex container. Applies `flex` by default; pass `className` to extend
* or override (tailwind-merge resolves conflicts so user classes win).
*
* @example
* ```tsx
* <Box className="gap-2 items-center">…</Box>
* <Box as="nav" className="flex-col gap-4">…</Box>
* ```
*/
var Box = React.forwardRef(({ className, children, analyticsName, trackImpression, ...props }, ref) => {
	return /* @__PURE__ */ jsx(Container, {
		ref: useImpressionRef(Boolean(analyticsName && trackImpression), analyticsName, "boxViewEvent", ref),
		className: cn("flex", className),
		...props,
		children
	});
});
Box.displayName = "Box";
/**
* Convenience wrapper that renders a `<Box>` with `flex-row` applied.
* Accepts all the same props as Box; `className` can still override.
*
* @example
* ```tsx
* <Row className="gap-2 items-center">…</Row>
* ```
*/
var Row = React.forwardRef(({ className, ...props }, ref) => {
	return /* @__PURE__ */ jsx(Box, {
		ref,
		className: cn("flex-row", className),
		...props
	});
});
Row.displayName = "Row";
/**
* Convenience wrapper that renders a `<Box>` with `flex-col` applied.
* Accepts all the same props as Box; `className` can still override.
*
* @example
* ```tsx
* <Col className="gap-2">…</Col>
* ```
*/
var Col = React.forwardRef(({ className, ...props }, ref) => {
	return /* @__PURE__ */ jsx(Box, {
		ref,
		className: cn("flex-col", className),
		...props
	});
});
Col.displayName = "Col";
//#endregion
export { Box, Col, Row };

